// enumUtils.js

// Helper method to get enum display value from key
export const getEnumValue = (enumObject, key) => {
  if (!key || !enumObject) return key

  return enumObject[key] || key
}

export const getEnumKey = (enumObject, value) => {
  if (!value || !enumObject) return value

  return Object.keys(enumObject).find(key => enumObject[key] === value) || value
}

/**
  Tries to get the enum key from the value
  @param {Object} enumObject - The enum object
  @param {string} value - The value to get the enum value from
  @returns {string | null} The enum value or null if not found
 */
const tryFrom = (enumObject, value) => {
  if (!value || !enumObject) return null

  return enumObject[value] ?? null
}

export const EnumUtils = () => {
  return {
    tryFrom,
  }
}
